import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/AcquireFooter';
import { SEOHead } from '../components/SEO/SEOHead';
import { ArrowRight } from 'lucide-react';
export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle login logic here
    console.log('Login attempt:', {
      email,
      password
    });
  };
  const handleGoogleSignIn = () => {
    // Handle Google OAuth login
    console.log('Google sign in initiated');
  };
  return <>
      <SEOHead title="Log In - AcquireFlow" description="Log in to your AcquireFlow account to manage your automated MLS offers and track your real estate deals." canonical="https://acquireflow.com/login" data-id="element-2663" />

      <div className="flex flex-col min-h-screen bg-gradient-to-b from-[#070707] via-[#0a0a0a] to-[#070707]" data-id="element-2664">
        <Navbar data-id="element-2665" />

        <main className="flex-grow flex items-center justify-center px-6 py-20" data-id="element-2666">
          <div className="w-full max-w-md" data-id="element-2667">
            {/* Login Card */}
            <div className="bg-gradient-to-br from-[#1a1a1a]/80 to-[#0f0f0f]/80 border border-white/10 rounded-2xl p-8 backdrop-blur-md" data-id="element-2668">
              {/* Header */}
              <div className="text-center mb-8" data-id="element-2669">
                <h1 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-2670">
                  Welcome Back
                </h1>
                <p className="text-[#b8bcc8]" data-id="element-2671">
                  Log in to your AcquireFlow account
                </p>
              </div>

              {/* Google Sign In Button */}
              <button onClick={handleGoogleSignIn} className="w-full flex items-center justify-center gap-3 bg-white hover:bg-gray-50 text-gray-900 font-medium py-4 rounded-xl transition-all duration-300 hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#0a0a0a] mb-6" data-id="element-2672">
                <svg className="w-5 h-5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-2673">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" data-id="element-2674" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" data-id="element-2675" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" data-id="element-2676" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" data-id="element-2677" />
                </svg>
                Continue with Google
              </button>

              {/* Divider */}
              <div className="relative my-6" data-id="element-2678">
                <div className="absolute inset-0 flex items-center" data-id="element-2679">
                  <div className="w-full border-t border-white/10" data-id="element-2680"></div>
                </div>
                <div className="relative flex justify-center text-sm" data-id="element-2681">
                  <span className="px-4 bg-gradient-to-br from-[#1a1a1a]/80 to-[#0f0f0f]/80 text-[#b8bcc8]" data-id="element-2682">
                    Or continue with email
                  </span>
                </div>
              </div>

              {/* Login Form */}
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2683">
                {/* Email Field */}
                <div data-id="element-2684">
                  <label htmlFor="email" className="block text-sm font-medium text-white mb-2" data-id="element-2685">
                    Email Address
                  </label>
                  <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-[#b8bcc8]/50 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:border-transparent transition-all" placeholder="you@example.com" required data-id="element-2686" />
                </div>

                {/* Password Field */}
                <div data-id="element-2687">
                  <div className="flex justify-between items-center mb-2" data-id="element-2688">
                    <label htmlFor="password" className="block text-sm font-medium text-white" data-id="element-2689">
                      Password
                    </label>
                    <a href="#" className="text-sm text-[#3ab795] hover:text-[#2da07d] transition-colors" data-id="element-2690">
                      Forgot password?
                    </a>
                  </div>
                  <input type="password" id="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-[#b8bcc8]/50 focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:border-transparent transition-all" placeholder="••••••••" required data-id="element-2691" />
                </div>

                {/* Remember Me */}
                <div className="flex items-center" data-id="element-2692">
                  <input type="checkbox" id="remember" className="w-4 h-4 rounded border-white/10 bg-white/5 text-[#3ab795] focus:ring-[#3ab795] focus:ring-offset-0" data-id="element-2693" />
                  <label htmlFor="remember" className="ml-2 text-sm text-[#b8bcc8]" data-id="element-2694">
                    Remember me for 30 days
                  </label>
                </div>

                {/* Submit Button */}
                <button type="submit" className="w-full flex items-center justify-center gap-3 bg-[#3ab795] hover:bg-[#2da07d] text-white font-medium py-4 rounded-xl transition-all duration-300 hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-[#3ab795] focus:ring-offset-2 focus:ring-offset-[#0a0a0a]" data-id="element-2695">
                  Log In
                  <ArrowRight className="w-5 h-5" data-id="element-2696" />
                </button>
              </form>

              {/* Divider */}
              <div className="relative my-8" data-id="element-2697">
                <div className="absolute inset-0 flex items-center" data-id="element-2698">
                  <div className="w-full border-t border-white/10" data-id="element-2699"></div>
                </div>
                <div className="relative flex justify-center text-sm" data-id="element-2700">
                  <span className="px-4 bg-gradient-to-br from-[#1a1a1a]/80 to-[#0f0f0f]/80 text-[#b8bcc8]" data-id="element-2701">
                    Don't have an account?
                  </span>
                </div>
              </div>

              {/* Sign Up Link */}
              <div className="text-center" data-id="element-2702">
                <a href="/trial" className="inline-flex items-center gap-2 text-[#3ab795] hover:text-[#2da07d] font-medium transition-colors" data-id="element-2703">
                  Start your free trial
                  <ArrowRight className="w-4 h-4" data-id="element-2704" />
                </a>
              </div>
            </div>

            {/* Security Note */}
            <p className="text-center text-sm text-[#b8bcc8]/70 mt-6" data-id="element-2705">
              Protected by industry-standard encryption and security measures
            </p>
          </div>
        </main>

        <Footer data-id="element-2706" />
      </div>
    </>;
}